// extracted by css-extract-rspack-plugin
export default {"calendarIcon":"ListHeader-module__calendarIcon__LbPn1lM","breadcrumbItem":"ListHeader-module__breadcrumbItem__OgTAeuw"};